/**
 * Who reviews a submission internally. Pure and shared with the browser, so the
 * submit control names the destination the server will route to.
 *
 * @module server/reviewer-requirement
 */

import type { ProgrammeResponsibilityAssignment, TenantMembership } from "./types";

/** Why a submission skipped internal review, as the panel and the audit trail say it. */
export const NO_INTERNAL_REVIEWER = "No internal reviewer assigned";

/**
 * Reviewers a submission would name: a `reviewer` responsibility whose holder
 * is an active member and an active user.
 */
export function activeReviewerUserIds(
  responsibilities: readonly Pick<ProgrammeResponsibilityAssignment, "responsibility" | "userId">[],
  memberships: readonly Pick<TenantMembership, "status" | "userId">[],
  activeUserIds: ReadonlySet<string>,
): string[] {
  const activeMembers = new Set(
    memberships
      .filter((membership) => membership.status === "active")
      .map((membership) => membership.userId),
  );
  return [
    ...new Set(
      responsibilities
        .filter((assignment) => assignment.responsibility === "reviewer")
        .map((assignment) => assignment.userId)
        .filter((userId) => activeMembers.has(userId) && activeUserIds.has(userId)),
    ),
  ];
}
